import { Stack, Typography } from '@mui/joy';
import { createFileRoute } from '@tanstack/react-router';
import type { ColumnDef } from '@tanstack/react-table';
import { createColumnHelper } from '@tanstack/react-table';
import dayjs from 'dayjs';

import { BackendTable } from '@/components/backend/table/BackendTable';
import { ErrorAlert } from '@/components/errors/ErrorAlert';
import { ButtonLink } from '@/components/router/ButtonLink';
import type { SystemNotification } from '@/modules/api';
import { useSystemNotificationQuery } from '@/queries/useSystemNotificationQuery';

export const Route = createFileRoute('/verwaltung/_global/benachrichtigungen/')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteComponent,
});

const columnHelper = createColumnHelper<SystemNotification>();

const columns = [
  columnHelper.accessor('title', {
    header: 'Titel',
    enableColumnFilter: false,
  }),
  columnHelper.accessor('content', {
    header: 'Inhalt',
    enableColumnFilter: false,
    cell: (info) => {
      const value = info.getValue();

      return value && value.length > 80 ? `${value.slice(0, 80)}…` : value;
    },
  }),
  columnHelper.accessor('validFrom', {
    header: 'Gültig von',
    size: 64,
    cell: (info) => dayjs(info.getValue()).format('L'),
    enableGlobalFilter: false,
    enableColumnFilter: false,
  }),
  columnHelper.accessor('validTo', {
    header: 'Gültig bis',
    size: 64,
    cell: (info) => dayjs(info.getValue()).format('L'),
    enableGlobalFilter: false,
    enableColumnFilter: false,
  }),
  columnHelper.accessor('createdAt', {
    header: 'Erstellt am',
    size: 64,
    cell: (info) => dayjs(info.getValue()).format('L'),
    enableGlobalFilter: false,
    enableColumnFilter: false,
  }),
] as ColumnDef<SystemNotification>[];

function RouteComponent() {
  const { data, isFetching, error } = useSystemNotificationQuery('ALL');

  if (error) {
    return <ErrorAlert error={error} />;
  }

  return (
    <Stack gap={2}>
      <Typography level="h2">Benachrichtigungen</Typography>
      <BackendTable
        fullHeight
        columns={columns}
        data={data}
        getRowId={(row) => row.id}
        isFetching={isFetching}
        onClickNavigate={(row) => `/verwaltung/benachrichtigungen/${row.id}`}
        searchInputPlaceholder="Benachrichtigungen durchsuchen"
        subject="Benachrichtigungen"
      />
      <ButtonLink sx={{ width: 'fit-content' }} to="/verwaltung/benachrichtigungen/hinzufuegen">
        hinzufügen
      </ButtonLink>
    </Stack>
  );
}
